module.exports = __webpack_public_path__ + "static/media/picard4.06aedbcb.jpg";